import { Dispatch, SetStateAction } from 'react';

import { Button } from 'coreOld/components';
import { Grid } from 'coreOld/elements';
import { Size } from 'coreOld/enums';
import { roundNumberWithUom } from 'coreOld/utils';
import CostForm from 'partsOld/components/CostForm';
import { ICompanyPart, ICost } from 'partsOld/types';

import { Item, TitleWrapper, Wrapper } from './costingHeaderStyle';

const ADD_BTN = 'Add';

interface IProps {
  part?: Partial<ICompanyPart>;
  selectedCost?: ICost;
  setSelectedCost: Dispatch<SetStateAction<ICost>>;
  setIsFormOpen: Dispatch<SetStateAction<boolean>>;
  isFormOpen: boolean;
}

const CostingHeaderView = ({
  part,
  isFormOpen,
  setIsFormOpen,
  selectedCost,
  setSelectedCost,
}: IProps) => {
  return (
    <Wrapper>
      <TitleWrapper>
        <Item bold>Costing</Item>
        <Button size={Size.XS} onClick={() => setIsFormOpen(true)}>
          {ADD_BTN}
        </Button>
      </TitleWrapper>

      <Grid container spacing={1}>
        <Grid item md={3} sm={6} xs={12}>
          <Item>Standard Cost</Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item bold>
            {roundNumberWithUom(part?.bomStdCost, part?.bomPriceDecimals, part?.purchaseCostUom)}
          </Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item>Package Cost</Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item bold>
            {roundNumberWithUom(part?.packageCost, part?.bomPriceDecimals, part?.packageUom)}
          </Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item>Purchase Cost</Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item bold>
            {roundNumberWithUom(part?.purchaseCost, part?.bomPriceDecimals, part?.purchaseCostUom)}
          </Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item>External Cost</Item>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Item bold>
            {roundNumberWithUom(part?.purchaseCost, part?.bomPriceDecimals, part?.externalUom)}
          </Item>
        </Grid>
      </Grid>

      <CostForm
        isFormOpen={isFormOpen}
        setIsFormOpen={setIsFormOpen}
        selectedCost={selectedCost}
        part={part}
        setSelectedCost={setSelectedCost}
      />
    </Wrapper>
  );
};

export default CostingHeaderView;
